export default __webpack_public_path__ + "static/media/Overall schedule1.b4ca0b92.png";